export default __webpack_public_path__ + "static/media/favicon.b4939079.ico";